import { AUTO_SYNC_DISABLE_ASYNC, GD_ADMIN_EMAIL_CHANGE } from './constants'

const autoSyncDisable = () => ({ type: AUTO_SYNC_DISABLE_ASYNC.INITIATE })
export const autoSyncDisableSuccess = () => ({
  type: AUTO_SYNC_DISABLE_ASYNC.SUCCESS,
})
export const autoSyncDisableError = (error) => ({
  type: AUTO_SYNC_DISABLE_ASYNC.ERROR,
  error,
})

export const gdAdminEmailChange = (val) => ({
  type: GD_ADMIN_EMAIL_CHANGE,
  payload: { val },
})

export default {
  // to props
  autoSyncDisable,
  gdAdminEmailChange,
}
